import axios from 'axios';
import { BLOG, getEnv } from './env';

const urlBackend = getEnv(BLOG);

const serviceBlog = async (baseURL) => {
  try {
    const response = await axios.get(baseURL);
    // Expect the API to return { data: { data: [...] } } or similar
    return response?.data?.data ?? [];
  } catch (error) {
    // In prerender environment the backend may be unreachable; return empty list
    console.warn('serviceBlog request failed, returning empty data for prerender:', error.message);
    return [];
  }
};

export const getFeaturedNotes = async () => {
  const urlFeaturedNotes = `${urlBackend}/api/get_featured_note_preview`;
  return serviceBlog(urlFeaturedNotes);
};

export const getOtherNotes = async (id) => {
  const urlOtherNotes = `${urlBackend}/api/get_note_preview/${id}`;
  return serviceBlog(urlOtherNotes);
};

export const getSpecificNote = async (id) => {
  const urlSpecificNote = `${urlBackend}/api/get_note/${id}`;
  return serviceBlog(urlSpecificNote);
};
